export enum TypeOfRemuneration {
  GEHALT = 'GEHALT',
  LOHN = 'LOHN',
}
